/// <reference path="../../libs/focus-trap.js" />
/// <reference path="../../framework/local-storage.js" />
/*
 * PDP component that manages the interactions of the recently viewed products
 */
(function ($) {
    $(function () {
        const STORAGE_KEY = "RecentlyViewed",
            MAX_PRODUCTS_TO_SHOW_ON_PDP = 6, // need to add one because we slice the array of items from index 0 later on
            MAX_PRODUCTS_TO_SHOW_ON_RESULTS = 5,
            MAX_PRODUCTS_TO_STORE = 40, // max number of products kept in storage and number shown on standalone page
            selectors = {
                outerContainer: "#results-recently-viewed-container",
                container: "#breadcrumb-recent-mini-container",
                miniList: "#recent-minis",
                recentText: "#recent-text",
            },
            recentlyViewedProductPages = evo.storage.getItem(STORAGE_KEY) || [],
            $container = $(selectors.container),
            productPageId = $container.attr("data-product-page-id"),
            dataLoadUrl = $container.attr("data-load-url");

        // if there's no data load URL then we can't do anything
        if (typeof dataLoadUrl === "undefined") {
            return;
        }

        const isResultsPage = typeof productPageId === "undefined";
        let productPagesToShow;

        if (isResultsPage) {
            // include last-seen product on results pages
            recentlyViewedProductPages.length = Math.min(
                recentlyViewedProductPages.length,
                MAX_PRODUCTS_TO_SHOW_ON_RESULTS,
            );
            productPagesToShow = recentlyViewedProductPages.slice(
                0,
                recentlyViewedProductPages.length,
            );
        } else {
            // add current page id to storage and remove any duplicates, only unshift if the product page ID isn't undefined
            recentlyViewedProductPages.unshift(productPageId);
            for (var i = 1; i < recentlyViewedProductPages.length; i++) {
                if (recentlyViewedProductPages[i] === productPageId) {
                    recentlyViewedProductPages.splice(i, 1);
                    break;
                }
            }
            // ensure the list of ids doesn't get too big
            recentlyViewedProductPages.length = Math.min(
                recentlyViewedProductPages.length,
                MAX_PRODUCTS_TO_STORE,
            );
            evo.storage.setItem(STORAGE_KEY, recentlyViewedProductPages);

            // Trim pages array to number of items shown on PDP
            recentlyViewedProductPages.length = Math.min(
                recentlyViewedProductPages.length,
                MAX_PRODUCTS_TO_SHOW_ON_PDP,
            );

            productPagesToShow = recentlyViewedProductPages.slice(
                1,
                recentlyViewedProductPages.length,
            );
        }

        if (productPagesToShow.length === 0) {
            return;
        }

        $.ajax({
            cache: false,
            data: $.param({ProductPageIds: productPagesToShow}, true),
            method: "GET",
            url: dataLoadUrl,
        })
            .done(function (response) {
                const isCanadaMode = dataLoadUrl.includes("/en-ca");
                const minis = response.map((recentlyViewedProduct) => {
                    const href = isCanadaMode
                        ? `/en-ca${recentlyViewedProduct.relativePath}`
                        : recentlyViewedProduct.relativePath;
                    const $link = $(
                        `<a href="${href}">` +
                        `<img class="breadcrumb-recent-mini" src="${recentlyViewedProduct.imageUrl}" alt="${recentlyViewedProduct.name}"/>` +
                        `</a>`,
                    );

                    $link.on('click', function (e) {
                        window.dataLayerManager.pushProductClick(recentlyViewedProduct.productId);
                    });

                    return $link;
                });

                // show the container if there are recently viewed items
                if (minis.length) {
                    $(selectors.miniList).append(minis).css("visibility", "visible");
                    $(selectors.container).css("visibility", "visible");
                    $(selectors.outerContainer).css("display", "flex");
                    $(selectors.recentText).css("visibility", "visible");
                    const impressions = response.map((recentlyViewedProduct) => {
                        return {
                            brand: recentlyViewedProduct.brand,
                            isOutlet: recentlyViewedProduct.isOutlet,
                            marketingPrice: recentlyViewedProduct.marketingPrice,
                            name: recentlyViewedProduct.name,
                            price: recentlyViewedProduct.price.minimum,
                            category: recentlyViewedProduct.coreTaxonomyNodePath,
                            id: recentlyViewedProduct.productId,
                            _uniqueId: recentlyViewedProduct.productId,
                        }
                    });
                    window.dataLayerManager.pushImpressions(impressions, 'Recently Viewed - ' + (isResultsPage ? 'results' : 'PDP'), true);
                }
            })
            .fail(function () {
                console.warn(
                    "There was an error loading the recently viewed component",
                );
            });
    });
})(jQuery);
